import {
  StyledTransactionList,
  StyledTransactionListHeader,
} from 'components/account-center/styled'
import { notifyTransactionReceipt } from 'components/notifications'
import React from 'react'
import { Transaction, storedTransactionsAtom, useTransactionService } from 'services'
import { useStore } from 'services/store'
import { useMultiTransactionState } from '../../../../../services/pending-transactions-context'
import TransactionList from '../list-components/list'
import { StyledClearText, TransactionListHeaderWrapper } from '../style'

import { useAtomValue } from 'jotai'
import { TransactionStatus } from 'sdk/omni/omni-transaction-service/types'
import { useAccount } from 'wagmi'

/**
 * Presentation component for individual transactions list
 */
const TransactionListWrapper: React.FC = () => {
  const { isDarkMode } = useStore()
  const { clearTransactions } = useTransactionService()

  const { completed } = useMultiTransactionState()
  const { address } = useAccount()
  const transactions = useAtomValue(storedTransactionsAtom)
  const [hoistedTransactions, setHoistedTransactions] = React.useState<(string | undefined)[]>([])

  const filteredTransactions = transactions.filter((item) => item.account === address)
  const completedTransactions = (item: Transaction) =>
    item.status === TransactionStatus.INFLIGHT && !hoistedTransactions.includes(item.hash)

  React.useEffect(() => {
    filteredTransactions.filter(completedTransactions).forEach((transaction) => {
      hoistedTransactions.length !== 0
        ? setHoistedTransactions([...hoistedTransactions, transaction.hash])
        : setHoistedTransactions([transaction.hash])
      notifyTransactionReceipt(transaction, isDarkMode)
    })
  }, [transactions])

  return (
    <StyledTransactionList>
      <TransactionListHeaderWrapper>
        <StyledTransactionListHeader>Completed transactions</StyledTransactionListHeader>
        {completed.length > 0 && (
          <StyledClearText onClick={clearTransactions}>Clear history</StyledClearText>
        )}
      </TransactionListHeaderWrapper>
      <TransactionList transactions={completed} showTimeStamp={true} pastTense={true} />
    </StyledTransactionList>
  )
}

export default TransactionListWrapper
